import { Fingerprint, type LucideProps } from 'lucide-react'

export function SkillsIcon({ className, ...props }: LucideProps) {
    return (
        <Fingerprint
            strokeWidth={1.25}
            className={className}
            {...props}
        />
    )
}

export function SkillsIconGradient({ className, ...props }: LucideProps) {
    return (
        <Fingerprint
            strokeWidth={1.25}
            className={className}
            stroke="url(#skills-icon-gradient)"
            {...props}
        >
            <defs>
                <linearGradient id="skills-icon-gradient" x1="2" y1="2" x2="22" y2="22" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#2563EB" />
                    <stop offset="1" stopColor="#9333EA" />
                </linearGradient>
            </defs>
        </Fingerprint>
    )
}
